import { render, staticRenderFns } from "./leaveDetailSimple.vue?vue&type=template&id=194fb30e&scoped=true"
import script from "./leaveDetailSimple.vue?vue&type=script&lang=js"
export * from "./leaveDetailSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194fb30e",
  null
  
)

export default component.exports